import { ref } from 'vue';

export function useCodeRunner(initial = '') {
  const code = ref(initial);
  const output = ref<string[]>([]);

  function run() {
    const logs: string[] = [];
    const orig = console.log;
    console.log = (...args: any[]) => {
      logs.push(
        args
          .map((a) => (typeof a === 'string' ? a : JSON.stringify(a, null, 2)))
          .join(' '),
      );
    };
    try {
      new Function(code.value)();
      output.value = logs.length ? logs : ['(no output)'];
    } catch (e: any) {
      output.value = ['Error: ' + (e?.message ?? String(e))];
    } finally {
      console.log = orig;
    }
  }

  function clear() {
    output.value = [];
  }

  return { code, output, run, clear };
}
